export const header = {
  showPartnerLogos: true,
  showBrand: true,
  showActions: true,

  fluid: true,
  sticky: false,

  variant: "light",

  desktop: {
    showPartnerLogos: true,
    showActions: true,
  },

  mobile: {
    showPartnerLogos: true,
    showActions: false,
  },
};